export default class extends HTMLElement {
  connectedCallback () {
    this.target = this.querySelector('[data-countdown]')
    this.resetAt = parseInt(this.dataset.resetAt, 10)

    if (!this.resetAt) return

    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnectedCallback () {
    clearInterval(this.timer)
  }

  tick () {
    const remaining = Math.max(0, Math.floor((this.resetAt - Date.now()) / 1000))

    if (this.target) this.target.textContent = this.format(remaining)

    if (remaining <= 0) {
      clearInterval(this.timer)

      if (this.dataset.resettingText) this.textContent = this.dataset.resettingText

      if (this.dataset.reload === 'true') {
        setTimeout(() => window.location.reload(), 8000)
      }
    }
  }

  format (totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60
    const pad = (n) => String(n).padStart(2, '0')

    return hours > 0
      ? `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
      : `${pad(minutes)}:${pad(seconds)}`
  }
}
